import { defineComponent as _defineComponent } from 'vue'
import type { ModalController } from '@/helpers/modal-helper';
import { getCtr } from '@/helpers/modal-helper';

import BasicButton from '@/ui-components/BasicButton.vue';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    title: null,
    subTitle: null,
    closable: { type: Boolean, default: true },
    hasHeader: { type: Boolean, default: true },
    hasDoneButton: { type: Boolean },
    disableDoneButton: { type: Boolean }
  },
  emits: ["closed"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {





const mCtr = ref<ModalController | null>(null);

onMounted(async () => {
	mCtr.value = await getCtr();

	const modal = (await mCtr.value.getTop()) as HTMLIonModalElement;
	await modal?.onWillDismiss();
	emit('closed');
});

function close() {
	mCtr.value?.dismiss().catch(() => {});
	emit('closed');
}

return { __sfc: true,emit, mCtr, close, BasicButton, faTimes, jwCheckIcon }
}

})